// import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Entry, JurorSelection } from './entry';
import { ShowEntry } from './show-entry';
import { EntryImage } from './entry-image';
import { Stats } from './stats';

// Juror Site: Each year there is only 1 entry list
import Entries from '../assets/2023/entries.json';
import Corrections from '../assets/2023/corrections.json';

// Online Galleries
import ShowEntries from '../assets/2020/entriesfinal2020.json';
import ShowEntries21 from '../assets/2021/entriesfinal2021.json';
import ShowEntries22 from '../assets/2022/entriesfinal2022.json';
import ShowEntries23 from '../assets/2023/entriesfinal2023.json';

declare var api: any;
const smallestEntryArea = 140;

export interface IRawShowEntry {
  SubmissionID: string;

  FirstName: string;
  LastName: string;
  City: string;
  State: string;
  Country?: string;
  Title: string;
  Price: number;
  UnframedWidth: number;
  UnframedHeight: number;
  FramedWidth?: number;
  FramedHeight?: number;
  Filename: string;
  JurorSelection?: number;
  Award?: string;
}

export interface IRawEntry {
  SubmissionID: string;
  NumEntries: number;

  Title1: string;
  UnframedWidth1: number;
  UnframedHeight1: number;
  // FramedWidth1: number | null;
  // FramedHeight1: number | null;
  Description1: string;
  Url1: string;

  Title2: string;
  UnframedWidth2: number;
  UnframedHeight2: number;
  // FramedWidth2: number | null;
  // FramedHeight2: number | null;
  Description2: string;
  Url2: string;
}

@Injectable({
  providedIn: 'root'
})
export class EntryService {
  entries: Entry[];
  showentries55: ShowEntry[];
  showentries54: ShowEntry[];
  showentries53: ShowEntry[];
  showentries: ShowEntry[];
  stats: Stats;

  constructor() {
    this.entries = new Array();
    this.showentries55 = new Array();
    this.showentries54 = new Array();
    this.showentries53 = new Array();
    this.showentries = new Array();
    this.stats = new Stats();

    this.getRawShowEntries55().forEach(element => {
      const entry = new ShowEntry();

      entry.SubmissionID = element.SubmissionID;
      entry.FirstName = element.FirstName;
      entry.LastName = element.LastName;
      entry.City = element.City;
      entry.State = element.State;
      entry.Country = element.Country;
      entry.Title = element.Title;
      entry.Price = element.Price;

      entry.UnframedWidth = element.UnframedWidth;
      entry.UnframedHeight = element.UnframedHeight;
      entry.FramedWidth = element.FramedWidth;
      entry.FramedHeight = element.FramedHeight;

      entry.Filename = this.extractUrl(element.Filename);
      entry.TNFilename = this.buildTNUrl('2023', entry.SubmissionID, entry.Filename, element.JurorSelection);
      entry.Award = element.Award;

      // console.log(entry);
      this.showentries55.push(entry);
    });

    this.getRawShowEntries54().forEach(element => {
      const entry = new ShowEntry();

      entry.SubmissionID = element.SubmissionID;
      entry.FirstName = element.FirstName;
      entry.LastName = element.LastName;
      entry.City = element.City;
      entry.State = element.State;
      entry.Country = element.Country;
      entry.Title = element.Title;
      entry.Price = element.Price;

      entry.UnframedWidth = element.UnframedWidth;
      entry.UnframedHeight = element.UnframedHeight;
      entry.FramedWidth = element.FramedWidth;
      entry.FramedHeight = element.FramedHeight;

      entry.Filename = this.extractUrl(element.Filename);
      entry.TNFilename = this.buildTNUrl('2022', entry.SubmissionID, entry.Filename, element.JurorSelection);
      entry.Award = element.Award;

      // console.log(entry);
      this.showentries54.push(entry);
    });

    this.getRawShowEntries53().forEach(element => {
      const entry = new ShowEntry();

      entry.SubmissionID = element.SubmissionID;
      entry.FirstName = element.FirstName;
      entry.LastName = element.LastName;
      entry.City = element.City;
      entry.State = element.State;
      entry.Country = element.Country;
      entry.Title = element.Title;
      entry.Price = element.Price;

      entry.UnframedWidth = element.UnframedWidth;
      entry.UnframedHeight = element.UnframedHeight;
      entry.FramedWidth = element.FramedWidth;
      entry.FramedHeight = element.FramedHeight;

      entry.Filename = this.extractUrl(element.Filename);
      entry.TNFilename = this.buildTNUrl('2021', entry.SubmissionID, entry.Filename, element.JurorSelection);
      entry.Award = element.Award;

      // console.log(entry);
      this.showentries53.push(entry);
    });

    this.getRawShowEntries().forEach(element => {
      const entry = new ShowEntry();

      entry.SubmissionID = element.SubmissionID;
      entry.FirstName = element.FirstName;
      entry.LastName = element.LastName;
      entry.City = element.City;
      entry.State = element.State;
      entry.Country = element.Country;
      entry.Title = element.Title;
      entry.Price = element.Price;

      entry.UnframedWidth = element.UnframedWidth;
      entry.UnframedHeight = element.UnframedHeight;
      entry.FramedWidth = element.FramedWidth;
      entry.FramedHeight = element.FramedHeight;

      entry.Filename = this.extractUrl(element.Filename);
      entry.TNFilename = this.buildTNUrl('2020', entry.SubmissionID, entry.Filename, 1);

      // console.log(entry);
      this.showentries.push(entry);
    });

    this.getRawEntries().forEach(element => {
      const entry = new Entry();

      entry.raw = element;

      entry.submissionID = element.SubmissionID;
      entry.numEntries = element.NumEntries;

      entry.entryImage1 = new EntryImage();
      entry.entryImage1.title = element.Title1;
      entry.entryImage1.unframedWidth = element.UnframedWidth1;
      entry.entryImage1.unframedHeight = element.UnframedHeight1;

      entry.entryImage1.undersize = (entry.entryImage1.unframedWidth * entry.entryImage1.unframedHeight < smallestEntryArea);

      // entry.entryImage1.framedWidth = element.FramedWidth1;
      // entry.entryImage1.framedHeight = element.FramedHeight1;
      entry.entryImage1.description = element.Description1;
      entry.entryImage1.imgurl = this.extractUrl(element.Url1);
      entry.entryImage1.tnImgUrl = this.buildTNUrl('2023', entry.submissionID, entry.entryImage1.imgurl, 1);

      entry.entryImage2 = new EntryImage();
      entry.entryImage2.title = element.Title2;
      entry.entryImage2.unframedWidth = element.UnframedWidth2;
      entry.entryImage2.unframedHeight = element.UnframedHeight2;

      entry.entryImage2.undersize = (entry.entryImage2.unframedWidth * entry.entryImage2.unframedHeight < smallestEntryArea);

      // entry.entryImage2.framedWidth = element.FramedWidth2;
      // entry.entryImage2.framedHeight = element.FramedHeight2;
      entry.entryImage2.description = element.Description2;
      entry.entryImage2.imgurl = this.extractUrl(element.Url2);
      entry.entryImage2.tnImgUrl = this.buildTNUrl('2023', entry.submissionID, entry.entryImage2.imgurl, 2);

      if (entry.numEntries === 1 && entry.entryImage2.imgurl !== '') {
        console.log('WARN: ' + entry.submissionID + ' states 1 entry, yet has image2 as ' + entry.entryImage2.imgurl);
        entry.numEntries = 2;
      }
      if (entry.numEntries >= 1 && entry.entryImage1.imgurl === '') {
        console.log('WARN: ' + entry.submissionID + ' is missing an upload for image 1, title is ' + entry.entryImage1.title );
      }
      if (entry.numEntries === 2 && entry.entryImage2.imgurl === '') {
        console.log('WARN: ' + entry.submissionID + ' is missing an upload for image 2, title is ' + entry.entryImage2.title );
      }

      // console.log(entry);
      this.entries.push(entry);

      this.stats.unreviewedCount += entry.numEntries;
    });

    this.applyRatings();
   }

   public applyRatings() {
    const result = api.entriesGet();
    result.then(rr => {

      const ratings = {};
      for (const r of rr.data) {
          ratings[r.id] = r.rating;
      }

      for (const e of this.entries) {
        if (ratings[e.submissionID] !== undefined) {
          this.updateStats(e, ratings[e.submissionID]);

          e.jurorSelection = ratings[e.submissionID];
        }
      }
    });
   }

   public rateEntry(i: number, selection: JurorSelection): void {
      if (this.entries[i].jurorSelection === JurorSelection.FirstImage ||
               this.entries[i].jurorSelection === JurorSelection.SecondImage) {
        this.stats.yesCount--;
        if (this.entries[i].numEntries > 1) {
          // this.stats.noCount--;
        }
        this.stats.unreviewedCount += this.entries[i].numEntries;
      } else if (this.entries[i].jurorSelection === JurorSelection.NeitherImage) {
        this.stats.noCount -= 1; // this.entries[i].numEntries;
        this.stats.unreviewedCount += this.entries[i].numEntries;
      }

      this.updateStats(this.entries[i], selection);

      this.entries[i].jurorSelection = selection;

      api.rateEntry(this.entries[i].submissionID, selection);
   }

   private updateStats(entry: Entry, selection: JurorSelection) {
      this.stats.unreviewedCount -= entry.numEntries;
      if (selection === JurorSelection.FirstImage ||
              selection === JurorSelection.SecondImage) {
        this.stats.yesCount++;
        if (entry.numEntries > 1) {
          // this.stats.noCount++;
        }
      } else if (selection === JurorSelection.NeitherImage) {
        this.stats.noCount += 1;// entry.numEntries;
      }
   }

   private extractUrl(data: string): string {
      const pos = data.indexOf('] ');
      if (pos >= 0) {
        return data.substr(pos + 2, data.length);
      }

      return data;
   }

   private buildTNUrl(year: string, submissionId: string, url: string, num: number): string {
    const ext = url.split('.').pop();
    return 'https://watercolorwest.s3.us-west-1.amazonaws.com/' + year + '/tn/' + submissionId + '-' + num + '.' + ext.toLowerCase();
   }

   private getRawEntries(): IRawEntry[] {
      return Entries;//.concat(Corrections);
   }

   private getRawShowEntries(): IRawShowEntry[] {
    return ShowEntries;
   }

   private getRawShowEntries53(): IRawShowEntry[] {
    return ShowEntries21;
   }

   private getRawShowEntries54(): IRawShowEntry[] {
    return ShowEntries22;
   }

   private getRawShowEntries55(): IRawShowEntry[] {
    return ShowEntries23;
   }
}
